module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meal-menu-clone"
  }, [_c('page-bar'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('h3', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "page-title"
  }, [_vm._v("Duplicar cardápio")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "to": "/meal-menu"
    }
  }, [_vm._v("\n\t\t\t\tVoltar\n\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('fieldset', [(_vm.mealMenuClone && _vm.mealMenuClone.length) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "note note-success"
  }, [_c('h4', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "block"
  }, [_vm._v("Duplicando cardápio")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("enum")(_vm.params.recipientGroup, 'RecipientsGroupType')) + "\n\t\t\t\t\t\t\t\t\t"), (_vm.params.recipientGroup !== 'ALL_SCHOOL') ? _c('span', [(_vm.params.recipientGroup === 'PER_LEVEL') ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t(" + _vm._s(_vm._f("enum")(_vm.params.level, 'SchoolClassLevelType')) + ")\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.params.recipientGroup === 'PER_GRADE') ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t(" + _vm._s(_vm._f("enum")(_vm.params.grade.level, 'SchoolClassLevelType')) + " >\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.params.grade.description) + ")\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.params.recipientGroup === 'PER_CLASS') ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t(" + _vm._s(_vm.params.schoolClass.schoolClassGrade.description) + " >\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.params.schoolClass.description) + ")\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t, "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("do periodo de ")]), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(_vm.params.startDate, 'DD')) + "\n\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v("à")]), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(_vm.params.endDate, 'DD')) + "\n\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v("de")]), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("enum")(_vm.params.month.value, 'Month')) + "\n\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v("de")]), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.params.year) + "\n\t\t\t\t\t\t\t\t")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('recipients-group', {
    attrs: {
      "label": 'Selecione a configuração do cardápio',
      "selected": _vm.recipientGroup
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.recipientGroup === 'PER_LEVEL') ? _c('class-level', {
    attrs: {
      "label": 'Selecione um nível de ensino',
      "blacklist": ['Fundamental_2', 'EnsinoMedio']
    }
  }) : _vm._e(), _vm._v(" "), (_vm.recipientGroup === 'PER_GRADE') ? _c('class-grade', {
    attrs: {
      "label": 'Selecione um ano de ensino'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.recipientGroup === 'PER_CLASS') ? _c('school-class', {
    attrs: {
      "label": 'Selecione uma turma',
      "group": false
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), (_vm.recipientGroup) ? _c('fieldset', [_c('legend', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Para qual semana deseja duplicar o cardápio?")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('year', {
    attrs: {
      "label": 'Ano letivo',
      "group": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('month', {
    attrs: {
      "disabled": !_vm.year,
      "group": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('week', {
    attrs: {
      "show-first": false,
      "disabled": !_vm.year || !_vm.month || (_vm.month && _vm.month.index === -1),
      "group": false
    }
  })], 1)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mealMenuClone && _vm.mealMenuClone.length),
      expression: "mealMenuClone && mealMenuClone.length"
    }],
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-9 col-md-3"
  }, [_c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group"
    }
  }, [_c('a', {
    staticClass: "btn green-jungle",
    attrs: {
      "type": "button",
      "role": "button",
      "disabled": !_vm.formIsValid()
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Salvar")])])])])])]), _vm._v(" "), (_vm.mealMenuClone && _vm.mealMenuClone.length) ? _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-layout-fixed"
  }, [_c('thead', [_c('tr', {
    staticClass: "bg-yellow-gold font-white"
  }, _vm._l((_vm.mealMenuClone), function(item, $index) {
    return _c('th', {
      staticClass: "text-center"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(item.clonedDate, 'dddd')) + "\n\t\t\t\t\t\t\t\t\t")])
  })), _vm._v(" "), _c('tr', {
    staticClass: "bg-grey"
  }, _vm._l((_vm.mealMenuClone), function(item, $index) {
    return _c('th', {
      staticClass: "text-center"
    }, [_c('small', [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "f-w-n"
    }, [_vm._v("Duplicar de")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(item.clonedDate, 'DD/MM/YYYY')) + "\n\n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.date),
        expression: "item.date"
      }]
    }, [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "f-w-n"
    }, [_vm._v("para")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm._f("date")(item.date, 'DD/MM/YYYY')))])])])])
  })), _vm._v(" "), _c('tr', _vm._l((_vm.mealMenuClone), function(item, $index) {
    return _c('th', [(item.times.length) ? _c('button', {
      staticClass: "btn btn-xs btn-block red-flamingo",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeMealDay($index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tRemover cardápio\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()])
  }))]), _vm._v(" "), _c('tbody', [_c('tr', _vm._l((_vm.mealMenuClone), function(item, $index) {
    return _c('td', [_vm._l((item.times), function(meal, index) {
      return _c('div', {
        attrs: {
          "role": "form"
        }
      }, [_c('div', {
        staticClass: "well p-5"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "control-label"
      }, [_c('small', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Refeição")])]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (meal.type),
          expression: "meal.type"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        staticClass: "form-control input-sm",
        attrs: {
          "name": "meal-type",
          "disabled": item.isBefore
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(meal, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }],
        attrs: {
          "value": "",
          "selected": ""
        }
      }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.ENUM.MealTimeType), function(value, index) {
        return _c('option', {
          domProps: {
            "value": index
          }
        }, [_vm._v(_vm._s(value))])
      })], 2)]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "control-label"
      }, [_c('small', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Horário")])]), _vm._v(" "), _c('input', {
        directives: [{
          name: "mask",
          rawName: "v-mask",
          value: ('##:##'),
          expression: "'##:##'"
        }, {
          name: "model",
          rawName: "v-model",
          value: (meal.time),
          expression: "meal.time"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ({
            rules: {
              required: true,
              regex: /([01]\d|2[0-3]):([0-5]\d)/
            }
          }),
          expression: "{ rules: { required: true, regex: /([01]\\d|2[0-3]):([0-5]\\d)/} }"
        }],
        staticClass: "form-control input-sm",
        attrs: {
          "type": "text",
          "name": "meal-time",
          "disabled": item.isBefore
        },
        domProps: {
          "value": (meal.time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(meal, "time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "control-label"
      }, [_c('small', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Alimento")])]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (meal.meal),
          expression: "meal.meal"
        }],
        staticClass: "form-control input-sm",
        attrs: {
          "type": "text",
          "name": "meal-meal",
          "disabled": item.isBefore
        },
        domProps: {
          "value": (meal.meal)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(meal, "meal", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "control-label"
      }, [_c('small', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Bebida e/ou fruta")])]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (meal.beverage),
          expression: "meal.beverage"
        }],
        staticClass: "form-control input-sm",
        attrs: {
          "type": "text",
          "name": "meal-beverage",
          "disabled": item.isBefore
        },
        domProps: {
          "value": (meal.beverage)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(meal, "beverage", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "form-group m-b-0"
      }, [_c('button', {
        staticClass: "btn btn-sm btn-block red-mint",
        attrs: {
          "type": "button",
          "disabled": item.isBefore
        },
        on: {
          "click": function($event) {
            _vm.removeItem($index, index)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" "), _c('span', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Remover refeição")])])])])])
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.isBefore),
        expression: "!item.isBefore"
      }],
      staticClass: "form-group m-b-0"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-block yellow-gold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.addItem($index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Adicionar refeição")])])])], 2)
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-offset-9 col-md-3"
  }, [_c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group"
    }
  }, [_c('a', {
    staticClass: "btn green-jungle",
    attrs: {
      "type": "button",
      "role": "button",
      "disabled": !_vm.formIsValid()
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Salvar")])])])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45ffe4ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/app/meal-menu/clone/main.vue
// module id = 1062
// module chunks = 1